import Sidebar from "../../components/partials/Sidebar";
import Header from "../../components/partials/Header";
import Breadcrumb from "../../components/Breadcrumb";
import { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import "./style.css";
import moment from "moment";
import { formatAmount } from "./util";
import $ from "jquery";
import config from "../../config";
import axios from "axios";
import { millionComma, isStockTransferOnly, showCreatedByName, printStockTransfer } from "../../utils";
import printIcon from "../../images/icons/print.png";
import { uomConversion, uomConversionUnit } from "../Sale/util";
import TruncatedTextWithTooltip from "../../components/TruncatedTextWithTooltip";
import Tippy from "@tippyjs/react";
import { BiInfoCircle } from "react-icons/bi";
import { Modal } from "react-bootstrap";
import ItemViews from "../Master/Item/view";

function StockView(props) {
  const { id } = useParams();
  const location = useLocation();
  let filter = location.state?.currentFilter;
  let currentFilterState = location.state?.showFilter;
  let page = location.state?.currentPageNo;

  const [stock, setStock] = useState(location.state?.stock || []);
  const [user, setUser] = useState({});
  const [showPageLoader, setShowPageLoader] = useState(false);
  const [showItemModal, setShowItemModal] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const handleItemView = (data) => {
    setSelectedItemId(data);
    setShowItemModal(true);
  };
  const handleItemModalClose = () => {
    setShowItemModal(false);
    setSelectedItemId(null);
  };

  useEffect(function () {
    if (localStorage.getItem("inventory")) {
      setUser(JSON.parse(localStorage.getItem("inventory")).userData);
    }
  }, []);

  console.log(
    "sdsdsdsd",
    JSON.parse(localStorage.getItem("inventory")).userData,
  );

  const [godown, setGodown] = useState([]);
  useEffect(
    function () {
      setGodown(() => props.godown);
    },
    [props],
  );
  useEffect(function () {
    if (stock.length == 0) {
      $.post(
        `${config.apiUrl}/StockAdjustment/listStockAdjustment`,
        JSON.stringify({ stk_adj_id: id }),
        function (res) {
          setStock(res?.data?.list?.[0] || []);
        },
      );
    }
  }, []);

  console.log("stockstockstockstockstock", stock);

  const [listgodown, setListgodown] = useState([]);
  console.log("listgodownlistgodownlistgodown", listgodown);
  const [listbranch, setbranch] = useState([]);

  useEffect(() => {
    $.post(
      `${config.apiUrl}/godown/listGodown`,
      JSON.stringify({
        paginate: 0,
        is_active: 1,
        branch_id:
          stock?.from_branch ||
          JSON.parse(localStorage.getItem("inventory")).userData?.branch_data[0]
            ?.branch_id,
      }),
      function (res) {
        setListgodown(res?.data?.list || []);
        console.log("res?.data?.list res?.data?.list ", res?.data?.list);
      },
    );
  }, [stock, location]);

  const [listgodownTo, setListgodownTo] = useState([]);
  console.log("listgodownTo", listgodownTo);
  useEffect(() => {
    $.post(
      `${config.apiUrl}/godown/listGodown`,
      JSON.stringify({
        paginate: 0,
        is_active: 1,
        branch_id:
          stock.to_branch ||
          JSON.parse(localStorage.getItem("inventory")).userData?.branch_data[0]
            ?.branch_id,
      }),
      function (res) {
        setListgodownTo(res?.data?.list || []);
        console.log("res?.data?.list res?.data?.list ", res?.data?.list);
      },
    );
  }, [stock, location]);

  const token = JSON.parse(localStorage.getItem("inventory")).token;
  useEffect(() => {
    const axiosConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const fetchData = async () => {
      if (localStorage.getItem("inventory")) {
        try {
          const response = await axios.post(
            `${config.apiUrl}/branch/listBranch`,
            JSON.stringify({
              paginate: 0,
              is_active: 1,
            }),
            axiosConfig,
          );
          setbranch(response?.data?.data.list);
        } catch (error) { }
      }
    };

    fetchData();
  }, []);
  const itemDtl = {
    item_id: "",
    item_name: "",
    qty: "",
    rate: "",
    amount: "",
    godown_id: "",
    alt_conv: "",
    base_uom: "",
    alt_uom: "",
    uom: "",
    alt_qty: "",
    alt_price: "",
    alt_rate: "",
    base_rate: "",
    reason: "",
  };

  const initialState = {
    stk_adj_type: "",
    branch_id: "",
    narration: "",
    stk_adj_date: moment().format("YYYY-MM-DD"),
    item_dtl: [itemDtl],
    from_branch: "",
    to_branch: "",
    from_godown: "",
    to_godown: "",
    vehicle_no: "",
  };

  const [formInputs, setFormInputs] = useState(initialState);

  useEffect(() => {
    if (stock && Array.isArray(stock.item_dtl)) {
      let prod = [...stock?.item_dtl];

      for (let i = 0; i < prod?.length; i++) {
        let element = {};
        element = prod[i];
        if (element.uom == element.alt_uom) {
          let newProdDtl = {
            ...element,
            qty: element.alt_qty,
            alt_qty: element.qty,
          };
          prod[i] = newProdDtl;
        }
      }

      setFormInputs((prevState) => {
        let newState = {
          ...prevState,
          item_dtl: prod,
        };

        return newState;
      });
    }
  }, [stock]);

  const godownName = listgodown?.find(
    (el) => stock?.to_godown == el?.godown_id,
  )?.godown_name;

  console.log("Godown Name:", godownName, stock?.to_godown);
  return (
    <>
      <div className="d-flex min-vh-100" style={{ background: "#DAE5FF" }}>
        <Sidebar />
        <div
          id="pageLoader"
          style={{
            display: showPageLoader !== false ? "block" : "none",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.5)",
            zIndex: 99999,
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              color: "#fff",
              textAlign: "center",
            }}
          >
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p
              className="mt-2"
              style={{ fontSize: "16px", fontWeight: "bold" }}
            >
              {showPageLoader}
            </p>
          </div>
        </div>
        <div
          className="content m-1 p-2 position-relative"
          style={{ paddingBottom: "8rem" }}
        >
          <Header />
          <div className="d-flex align-items-center">
            <Breadcrumb
              path={
                isStockTransferOnly(user)
                  ? ["View", "Stock Transfer"]
                  : ["View", "Stock Adjustment"]
              }
            />
            <div className="ms-3 mb-2">
              <Tippy content="Print">
                <button
                  type="button"
                  className="btn border-0 p-0"
                  onClick={() =>
                    printStockTransfer(
                      id || stock?.stk_adj_id,
                      setShowPageLoader
                    )
                  }
                >
                  <img
                    src={printIcon}
                    className="img-fluid"
                    alt="Print"
                    style={{ width: "18px" }}
                  />
                </button>
              </Tippy>
            </div>
          </div>

          <main className="bg-white rounded-2" id="purchaseAdd">
            <div className="container-fluid p-2 position-relative">
              <Link
                to="/stock-adjustment"
                className="position-absolute text-decoration-none small"
                style={{ top: "-1.5rem", right: "0" }}
                state={{
                  backToCurrent: page,
                  appliedFilter: filter,
                  filterDisplay: currentFilterState,
                }}
              >
                Go Back to List
              </Link>
              <form autoComplete="off">
                <div className="row mb-1">
                  {user.role_id === 2 ? (
                    <div className="col-md-3">
                      <label htmlFor="buyer_id">Branch Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="buyer_id"
                        // value={stock?.branch_id || ""}
                        value={
                          props.branchList?.find(
                            (el) => stock?.branch_id === el?.value,
                          )?.label
                        }
                        disabled
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="col-md-3">
                    <label htmlFor="buyer_id">Stock Adjustment Type</label>
                    <input
                      type="text"
                      className="form-control"
                      id="buyer_id"
                      value={
                        props?.stockInType?.find(
                          (el) => stock?.stk_adj_type === el?.value,
                        )?.label
                      }
                      disabled
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="po_date">Date</label>
                    <input
                      type="text"
                      className="form-control"
                      id="po_date"
                      value={moment(
                        `${stock?.stk_adj_date}`?.substring(0, 10),
                      ).format("DD-MM-YYYY")}
                      disabled
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="po_date">Narration</label>
                    <input
                      type="text"
                      className="form-control"
                      id="po_date"
                      value={stock.narration}
                      disabled
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="vehicle_no">Vehicle No</label>
                    <input
                      type="text"
                      className="form-control"
                      id="vehicle_no"
                      value={stock.vehicle_no}
                      disabled
                    />
                  </div>


                  {stock?.stk_adj_type == 1 ? (
                    <>
                      <div className="col-md-3">
                        <label htmlFor="buyer_id">From Branch</label>
                        <input
                          type="text"
                          className="form-control"
                          id="buyer_id"
                          // value={stock?.branch_id || ""}
                          value={
                            listbranch?.find(
                              (el) => stock?.from_branch === el?.branch_id,
                            )?.branch_name
                          }
                          disabled
                        />
                      </div>
                      <div className="col-md-3">
                        <label htmlFor="buyer_id">From Godown</label>
                        <input
                          type="text"
                          className="form-control"
                          id="buyer_id"
                          // value={stock?.branch_id || ""}
                          value={
                            listgodown?.find(
                              (el) => stock?.from_godown == el?.godown_id,
                            )?.godown_name
                          }
                          disabled
                        />
                      </div>
                      <div className="col-md-3">
                        <label htmlFor="buyer_id">To Branch</label>
                        <input
                          type="text"
                          className="form-control"
                          id="buyer_id"
                          // value={stock?.branch_id || ""}
                          value={
                            listbranch?.find(
                              (el) => stock?.to_branch === el?.branch_id,
                            )?.branch_name
                          }
                          disabled
                        />
                      </div>
                      <div className="col-md-3">
                        <label htmlFor="buyer_id">To Godown</label>
                        <input
                          type="text"
                          className="form-control"
                          id="buyer_id"
                          // value={stock?.branch_id || ""}
                          // value={
                          //   listgodown?.find(
                          //     (el) => stock?.to_godown == el?.godown_id
                          //   )?.godown_name
                          // }

                          value={
                            listgodownTo?.find(
                              (el) => stock?.to_godown == el?.godown_id,
                            )?.godown_name
                          }
                          disabled
                        />
                      </div>
                      <div className="col-md-3">
                        <label htmlFor="buyer_id">Source Reason</label>
                        <textarea
                          type="text"
                          disabled
                          className="form-control"
                          id="cust_address"
                          value={stock?.source_reason}
                        />
                      </div>

                      <div className="col-md-3">
                        <label htmlFor="buyer_id">Destination Reason</label>
                        <textarea
                          type="text"
                          disabled
                          className="form-control"
                          id="cust_address"
                          value={stock?.destination_reason}
                        />
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  {showCreatedByName(user) && (
                    <div className="col-md-3">
                      <label htmlFor="created_by_name">Created By</label>
                      <input
                        type="text"
                        className="form-control"
                        id="created_by_name"
                        value={stock?.created_by_name || ""}
                        disabled
                      />
                    </div>
                  )}
                </div>

                <div className="row">
                  <div className="col-12">
                    <table
                      className="table mt-4 rounded"
                      cellPadding="0"
                      cellSpacing="0"
                    >
                      <thead>
                        <tr>
                          <th>
                            Item Name
                            {stock?.stk_adj_type != 1 && (
                              <th style={{ borderTop: "1px solid #ccc" }}>
                                Reason
                              </th>
                            )}
                          </th>
                          <th>UOM</th>
                          <th>Qty</th>
                          <th>Rate</th>
                          {stock?.stk_adj_type == 1 ? "" : <th>Godown</th>}
                          <th>Amount</th>
                          {stock?.stk_adj_type == 1 ? "" : <th>Status</th>}
                        </tr>
                      </thead>
                      <tbody>
                        {formInputs.item_dtl &&
                          formInputs.item_dtl.map((v, i) => (
                            <tr key={i}>
                              <td style={{ width: "430px" }}>
                                <div
                                  style={{
                                    display: "flex",
                                    // justifyContent: "center",
                                    alignItems: "center",
                                    gap: "1px",
                                  }}
                                >
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={v?.mst_item?.item_name}
                                    disabled
                                  />
                                  <Tippy content="View Item">
                                    <div>
                                      {" "}
                                      <span
                                        className=""
                                        style={{ cursor: "pointer" }}
                                        onClick={() => handleItemView(v)}
                                      >
                                        <BiInfoCircle size={20} />
                                      </span>
                                    </div>
                                  </Tippy>
                                </div>
                                {stock?.stk_adj_type != 1 && (
                                  <textarea
                                    type="text"
                                    rows="2"
                                    disabled
                                    className="form-control mt-2"
                                    id="reason"
                                    value={v?.reason}
                                  />
                                )}
                              </td>
                              <td style={{ width: "100px" }}>
                                {v?.alt_uom != null && v?.alt_uom != "" && (
                                  <select
                                    id=""
                                    name="uom"
                                    value={v?.uom}
                                    className="form-select"
                                    style={{ width: "100px" }}
                                    disabled
                                  >
                                    {[v.base_uom, v.alt_uom].map((ele, ind) => (
                                      <option value={ele}>{ele}</option>
                                    ))}
                                  </select>
                                )}
                              </td>
                              <td style={{ width: "110px" }}>
                                <input
                                  type="text"
                                  className="form-control text-end"
                                  value={v.qty}
                                  disabled
                                />
                                {v?.alt_uom != null && v?.alt_uom != "" && (
                                  <span
                                    className="text-right"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    <TruncatedTextWithTooltip
                                      text={uomConversionUnit(v)}
                                    />
                                  </span>
                                )}
                              </td>
                              <td style={{ width: "130px", maxWidth: "130px" }}>
                                <input
                                  type="text"
                                  className="form-control text-end"
                                  // value={millionComma(v.rate)}
                                  value={
                                    v?.uom == v?.alt_uom
                                      ? millionComma(v?.alt_price)
                                      : millionComma(v?.rate)
                                  }
                                  disabled
                                />
                                {/* {v?.alt_uom != null && v?.alt_uom != "" && (
                                  <span style={{ whiteSpace: "nowrap" }}>
                                    {`Per (`}
                                    <TruncatedTextWithTooltip text={v?.base_uom} />
                                    {`)`}
                                  </span>
                                )} */}

                                {v?.alt_uom != null &&
                                  v?.alt_uom !== "" &&
                                  (v?.uom == v?.alt_uom ? (
                                    <span style={{ whiteSpace: "nowrap" }}>
                                      {`( ${v?.rate} Per `}
                                      <TruncatedTextWithTooltip
                                        text={uomConversion(v)}
                                      />
                                      {`)`}
                                    </span>
                                  ) : (
                                    <span style={{ whiteSpace: "nowrap" }}>
                                      {`(${v?.alt_price} Per `}
                                      <TruncatedTextWithTooltip
                                        text={uomConversion(v)}
                                      />
                                      {`)`}
                                    </span>
                                  ))}
                              </td>
                              {stock?.stk_adj_type == 1 ? (
                                ""
                              ) : (
                                <td style={{ width: "170px" }}>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={
                                      godown?.find(
                                        (x) => x?.godown_id === v?.godown_id,
                                      )?.godown_name
                                    }
                                    disabled
                                  />
                                </td>
                              )}
                              {/* <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={
                                    godown?.find(
                                      (x) => x?.godown_id === v?.godown_id
                                    )?.godown_name
                                  }
                                  disabled
                                />
                              </td> */}
                              <td>
                                <input
                                  type="text"
                                  className="form-control text-end"
                                  value={millionComma(v.amount)}
                                  disabled
                                />
                              </td>
                              {stock?.stk_adj_type == 1 ? (
                                ""
                              ) : (
                                <td style={{ width: "90px" }}>
                                  <input
                                    type="text"
                                    className="form-control "
                                    value={
                                      v.apr_status == 1
                                        ? "Approved"
                                        : v.apr_status == 3
                                          ? "Rejected"
                                          : v.apr_status == 2
                                            ? "Pending"
                                            : " "
                                    }
                                    disabled
                                  />
                                </td>
                              )}
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </form>
            </div>
            <div className="container-fluid mt-5">
              <div className="row">
                <div className="col-12 position-absolute bottom-0 start-0 end-0">
                  <div
                    className="row rounded px-2 py-3"
                    style={{ background: "#F4F7FE" }}
                  >
                    <div className="col-md-3">
                      <label htmlFor="total">Gross Total</label>
                      <input
                        type="text"
                        className="form-control text-end"
                        id="total"
                        value={formatAmount(stock)}
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
      <Modal
        show={showItemModal}
        onHide={handleItemModalClose}
        keyboard={false}
        backdrop="static"
        size="lg"
      >
        <ItemViews id={selectedItemId} hide={handleItemModalClose} />
      </Modal>
    </>
  );
}

export default StockView;
